import theme from 'App.theme';
import Button from 'components/Button';

import React, { ComponentProps } from 'react';

type Props = {
  checkedText: string;
  uncheckedText: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
} & ComponentProps<'div'>;

export const Switch = ({ checkedText, uncheckedText, checked, onChange, style, ...props }: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: theme.layout.spacing.small,
        ...style,
      }}
      {...props}
    >
      <Button
        colors={checked ? 'white on active' : 'black on white'}
        onClick={() => onChange(true)}
        sx={{ width: '100%' }}
        disabled={!!props.disabled}
      >
        {checkedText}
      </Button>

      <Button
        colors={checked ? 'black on white' : 'white on red'}
        onClick={() => onChange(false)}
        sx={{ width: '100%' }}
        disabled={!!props.disabled}
      >
        {uncheckedText}
      </Button>
    </div>
  );
};
